import React from "react";
import I from "./Icon";
const Bdg = ({ type, label }) => {
  const m = { green: "bdg-g", red: "bdg-r", yellow: "bdg-y", blue: "bdg-b", purple: "bdg-pu" };
  return <span className={`bdg ${m[type] || "bdg-b"}`}><span className="bdg-dot" />{label}</span>;
};
export default Bdg;